// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2VI-A","range":"MonthRangeSwitch_range__1ngP7","disabled":"MonthRangeSwitch_disabled__2HtZX"};